export default __webpack_public_path__ + "static/subfactory-bg-f26f6261c93eabe8b18320ef5212680a.png";